const theme = {
    colors: {
        text: "#333",
        textLight: 'rgb(48, 51, 59, 0.3)',
        textSuperLight: 'rgb(48, 51, 59, 0.1)',
        background: "#fff",
        primary: "#fff",
        primaryLight: 'rgba(255, 255, 255, 0.2)',
        secondary: "#375FAD",
        bright: '#F4333F',
    },
    fonts: {
        body: "'Raleway', system-ui, sans-serif",
        heading: "'Raleway', system-ui, sans-serif",
        monospace: "Menlo, monospace",
    },
    fontWeights: {
        body: 400,
        heading: 700,
        bold: 700,
    },
    lineHeights: {
        body: 1.5,
        heading: 1.125,
    },
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72],
    space: [0, 4, 8, 12, 32, 40, 64, 128, 256, 512],
}

export default theme